export default __webpack_public_path__ + "static/media/ic-cake-bep20.4bfccbe7.svg";